import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { ConfirmBookingPaymentData, tokenRequests } from '../api/api';
import cacheQueryKeys from '../resources/queryCacheKeys';

export const useBookingConfirmPaymentData = () => {
  const query = useQuery<ConfirmBookingPaymentData>([cacheQueryKeys.ConfirmPaymentData]);
  return query.data;
};

export const useBookingConfirmationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(tokenRequests.confirmBooking, {
    onSuccess({ data }) {
      queryClient.setQueryData([cacheQueryKeys.ConfirmPaymentData], data);
    },
  });
};
